/***
*
*   PASSWORD
*   Update the users password
*
*   if the user has a password show old and new inputs
*   if no existing password (eg. in case of social signin)
*   then allow the user to set a password on their account
*
**********/

import React, { Fragment, useContext, useState } from 'react';
import { AuthContext, AccountNav, Animate, Card, Form, Message, useAPI } from 'components/lib';

export function Password(props){

  const context = useContext(AuthContext);
  const [done, setDone] = useState(false);
  const [userReloadKey, setUserReloadKey] = useState(0);
  const [generatedPin, setGeneratedPin] = useState(null);
  const user = useAPI('/api/user', 'get', userReloadKey);
  const hasPassword = user.data?.has_password ?? context.user?.has_password;
  const tranche2PinEnabled =
    user.data?.tranche2_risk_assessment_enabled_for_user === true;
  const riskAssessmentPinSet =
    user.data?.risk_assessment_pin_set === true || !!generatedPin;
  
  return (
    <Fragment>

      <AccountNav />
      <Animate>
      <Card
        title='Update Your Password'
        restrictWidth
        className={ props.className }
        loading={ user.loading }
      >

    { !done ?  
      <Form
        url='/api/user/password'
        method='PUT'
        buttonText='Save Password'
        data={{
          ...hasPassword && { 
            oldpassword: {
              label: 'Old Password',
              type: 'password',
              required: true
            },
            has_password: {
              type: 'hidden',
              value: true,
            }
          },
          newpassword: {
            label: 'Create New Password',
            type: 'password',
            required: true,
            complexPassword: true
          },
        }}
        callback={ () => {
          
          setDone(true);
          context.update({ has_password: true });

        }}
      /> : 
      <Message 
        title='Password Saved'
        type='success'
        text='Your new password has been saved successfully.'
      />
    }
    </Card>

    { tranche2PinEnabled &&
      <Card
        title='Risk Assessment PIN'
        restrictWidth
        className={ props.className }
        loading={ user.loading }
      >
        { generatedPin &&
          <Message
            title='PIN Updated'
            type='success'
            text='Store this PIN securely. It will not be shown again.'
          >
            <div className='mt-3 font-mono text-2xl tracking-[0.35em]'>
              { generatedPin }
            </div>
          </Message>
        }

        <Message
          title='Reviewer Access PIN'
          type={ riskAssessmentPinSet ? 'info' : 'warning' }
          text={
            riskAssessmentPinSet
              ? 'Resetting your PIN requires your current 6-digit PIN. A replacement PIN will be generated for you.'
              : 'Generate your 6-digit reviewer PIN now. It is system-generated and will only be shown once.'
          }
        />

        <Form
          url='/api/user/risk-assessment-pin'
          method='PUT'
          buttonText={
            riskAssessmentPinSet
              ? 'Reset Risk Assessment PIN'
              : 'Generate Risk Assessment PIN'
          }
          data={{
            ...riskAssessmentPinSet && {
              old_pin: {
                label: 'Current Risk Assessment PIN',
                type: 'password',
                required: true,
                placeholder: 'Enter your current 6-digit PIN',
              }
            }
          }}
          callback={ res => {

            setGeneratedPin(res.data.data.pin);
            setUserReloadKey(value => value + 1);
            context.update({ risk_assessment_pin_set: true });

          }}
        />
      </Card>
    }
    </Animate>
    
    </Fragment>
  );
}
